var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          ref: "directUpload",
          staticClass: "upLoadPicBox",
          attrs: {
            action: "#",
            multiple: _vm.limit > 1,
            limit: _vm.limit,
            "show-file-list": false,
            "file-list": _vm.uploadedFileList,
            "http-request": _vm.uploadRequest,
            "before-upload": _vm.beforeUpload,
            accept: _vm.accept,
            "on-exceed": _vm.handleExceed,
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-row-h-center img-box" },
            [
              _vm._l(_vm.uploadedFileList, function (item, index) {
                return _c("div", { key: item, staticClass: "upload" }, [
                  _c("div", [
                    _c(
                      "div",
                      {
                        class: ["upload-mask", "upload-mask-bgColor"],
                        style: { opacity: _vm.hoverIndex === index ? 1 : 0 },
                        on: {
                          click: function ($event) {
                            _vm.currentIndex = index
                          },
                          mouseenter: function ($event) {
                            _vm.hoverIndex = index
                          },
                          mouseleave: function ($event) {
                            _vm.hoverIndex = null
                          },
                        },
                      },
                      [
                        _vm.hoverIndex === index
                          ? _c("i", {
                              staticClass: "el-icon-delete delete-icon",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleRemove(index)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _c("img", {
                      staticClass: "upload-img",
                      attrs: { src: item.url, alt: "" },
                    }),
                  ]),
                ])
              }),
              _vm.limit > 1 || (_vm.limit === 1 && !_vm.uploadedFileList.length)
                ? _c("div", { staticClass: "upload" }, [
                    _c("i", {
                      staticClass: "el-icon-camera cameraIconfont",
                      on: {
                        click: function ($event) {
                          _vm.currentIndex = "add"
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }